import axios      from "axios"

import { isAuth } from "../Auth/email"
const base = `${process.env.REACT_APP_API}/ips`

/**
 * @description get all ip addresses
 */
const getAll = async () => {
	const url = `${base}/get-all`
	const jwt = isAuth()
	if (!jwt) {
		return "error"
	}

	return await axios.post(
		url,
		{},
		{
			headers: {
				Authorization: `Bearer ${jwt}`,
			},
			withCredentials: true,
		}
	)
}
const main = {
	getAll
}
export default main